<template>
  <!-- 运营标签 -->
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getLabelList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="标签名称">
            <el-input v-model="searchForm.labelName" placeholder="请输入标签名称" />
          </el-form-item>
          <el-form-item label="标签分类">
            <el-select v-model="searchForm.labelTitleId" placeholder="请选择标签分类">
              <el-option v-for="item in labelTitleList" :key="item.labelTitleId" :value="item.labelTitleId"
                :label="item.labelTitleName" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getLabelList, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getLabelList, { labelName: null, labelTitleId: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addLabel">新增标签</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteLabelList">批量删除</el-button>
      </div>
      <div>
        <!-- 标签列表 -->
        <el-table v-loading="loading" :data="labelList" ref="multipleTable" :max-height="tableHeight"
          @selection-change="val => $handleSelectionChange(val, true)" border>
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column prop="labelName" label="标签名称" />
          <el-table-column prop="labelTitleName" label="标签分类" />
          <el-table-column prop="createTime" label="创建时间" min-width="150" />
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="primary" @click="editLabel(scope.row)">编辑</el-button>
              <el-button icon="el-icon-delete" type="danger" @click="deleteLabel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getLabelList)" :total="total"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      </div>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="350px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="标签名称" prop="labelName">
            <el-input v-model="editForm.labelName" placeholder="请输入标签名称" />
          </el-form-item>
          <el-form-item label="标签分类" prop="labelTitleId">
            <el-select v-model="editForm.labelTitleId" placeholder="请选择标签分类">
              <el-option v-for="item in labelTitleList" :key="item.labelTitleId" :value="item.labelTitleId"
                :label="item.labelTitleName" />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增运营标签'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑运营标签'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script lang="js">
import { labelList, labelEdit, labelDelete, labelAdd, labelInfo, labelTitleList } from "@/api/operatelabel"; // 标签请求
export default {
  name: "OperateLabel",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { labelName: null, labelTitleId: null }, // 查询表单
      labelList: [], // 标签列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      editFormRules: {
        labelName: [{ required: true, message: "标签名称不能为空", trigger: "blur" }],
        labelTitleId: [{ required: true, message: "请选择标签类型", trigger: "change" }]
      }, // 验证规则
      labelTitleList: [], // 标签钱分类列表
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    this.getLabelTitleList(); // 获取标签分类列表
    this.getLabelList(); // 获取标签列表
  },
  methods: {
    // 请求标签分类列表
    async getLabelTitleList() {
      let { code, rows } = await labelTitleList();
      if (code == 200) this.labelTitleList = rows;
    },
    // 请求标签列表
    async getLabelList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await labelList(params);
      if (code == 200) {
        this.total = total;
        this.labelList = rows;
      }
      this.loading = false;
    },
    // 新增标签
    addLabel() {
      this.dialogVisible = true;
      this.dialogTitle = "新增运营标签";
      this.editForm = { labelName: null, labelTitleId: null };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          labelAdd(this.editForm).then(res => {
            if (res.code == 200) this.$message.success("新增运营标签成功！");
            this.dialogVisible = false;
            this.$refresh(this.getLabelList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除标签
    deleteLabel(row) {
      this.$confirm('确认删除该运营标签？').then(_ => { this.del(row.labelId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await labelDelete(id);
      if (code == 200) this.$message.success("删除标签成功！");
      this.$refresh(this.getLabelList);
    },
    // 批量删除标签
    deleteLabelList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何运营标签");
      else {
        selected.forEach(item => { selectedId.push(item.labelId) });
        this.$confirm('确认删除该运营标签？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    },
    // 编辑标签信息
    async editLabel(row) {
      let { data, code } = await labelInfo(row.labelId);
      if (code == 200) {
        this.editForm = data;
        this.dialogTitle = "编辑运营标签";
        this.dialogVisible = true;
      }
    },
    // 保存标签修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          labelEdit(this.editForm).then(res => {
            if (res.code == 200) this.$message.success("修改运营标签成功！");
            this.dialogVisible = false;
            this.$refresh(this.getLabelList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    }
  },
};
</script>